module.exports = __webpack_public_path__ + "static/img/zhengshu.5bdc92c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xinli/zhengshu.png
// module id = Xk1P
// module chunks = 2